import React from 'react';

import CopyToClipboard from '../../../common/CopyToClipboard';


const BuyerQuotesListWithNoPOModal = (props) => {
    const { buyerQuotesWithNoPOList } = props

    
    return (
        <div>
            <p>Please add a closure reason for the quotes below before proceeding to the new buyer quote. </p>
            {buyerQuotesWithNoPOList.length > 0 ? 
                <ul>
                    {buyerQuotesWithNoPOList.map((eachQuote) => (
                        <li key={`buyerQuote-${eachQuote.buyerQuoteId}`}>
                            <div>
                                <p className="m-0">
                                    <span > Quote No: </span>
                                    <span style={{ fontWeight: "bold" ,cursor: "pointer"}} className="ml-1" onClick={() => window.open(`/buyer/quotation/${eachQuote.buyerQuoteId}`, "_blank")}> 
                                        {eachQuote.docNo}
                                    </span>
                                    <span><CopyToClipboard text={eachQuote.docNo} />
                                    </span>
                                </p> <br />
                            </div>

                        </li>
                    ))}
                </ul>
                : 
                <p>No buyer quotes found.</p>
            }
        </div>
    )
}

export default BuyerQuotesListWithNoPOModal;